  
  //Global snippet for Rivo
  //this is updated automatically - do not edit manually.
 

  function loadMainScript(src, defer, done) {
    var js = document.createElement('script');
    js.src = src;
    js.defer = defer;
    js.onload = function(){done();};
    js.onerror = function(){
      done(new Error('Failed to load script ' + src));
    };
    document.head.appendChild(js);
  }
  function loadDataScript(src, defer, done) {
    var js = document.createElement('script');
    js.setAttribute('data-src', src);
    js.defer = defer;
    js.onload = function(){done();};
    js.onerror = function(){
      done(new Error('Failed to load script ' + src));
    };
    document.head.appendChild(js);
  }
  function loadScript(src, defer, done) {
    var js = document.createElement('script');
    js.src = src;
    js.defer = defer;
    js.onload = function(){done();};
    js.onerror = function(){
      done(new Error('Failed to load script ' + src));
    };
    document.head.appendChild(js);
  }

  function browserSupportsAllFeatures() {
    return window.Promise && window.fetch && window.Symbol;
  }

  if (browserSupportsAllFeatures()) {
    main();
  } else {
    loadScript('https://polyfill.io/v3/polyfill.min.js?features=Promise,fetch', true, main);
  }

  function loadAppScripts(){
    
    loadMainScript(window.Rivo.global_config.asset_urls.global.helper_js, true, function(){});    
    
    if (window.Rivo.global_config.aat.includes("loy")){
      //loadScript(window.Rivo.global_config.asset_urls.loy.init_js, false, function(){});
    }     

    if (window.Rivo.global_config.aat.includes("rev")){
      loadDataScript(window.Rivo.global_config.asset_urls.rev.init_js, false, function(){});
    }

    if (window.Rivo.global_config.aat.includes("pu")){
      loadDataScript(window.Rivo.global_config.asset_urls.pu.init_js, false, function(){});
    }

    if (window.Rivo.global_config.aat.includes("pop") || window.Rivo.global_config.aat.includes("pu")){
      loadDataScript(window.Rivo.global_config.asset_urls.widgets.init_js, false, function(){});
    }
  }

  function main(err) { 
    loadMainScript(window.Rivo.global_config.asset_urls.global.helper_js, true, loadAppScripts);   
  } 